export const personnel = {
  isSeniorStaff: [
    {
      label: '是',
      value: 1
    }, {
      label: '否',
      value: 0
    }
  ],
  registerTimeType: [
    {
      label: '注册时间',
      value: 1
    }, {
      label: '申请认证时间',
      value: 2
    }
  ],
  approveType: [
    {
      label: '未认证',
      value: 1
    }, {
      label: '已认证',
      value: 2
    }, {
      label: '内部业务员',
      value: 3
    }, {
      label: '认证未通过',
      value: 4
    }
  ],
  attestationTypeNew: [
    {
      label: '待审批',
      value: 1
    }, {
      label: '未通过',
      value: 2
    }, {
      label: '已通过',
      value: 3
    }
  ],
  attestationType: [
    {
      label: '待审批',
      value: 1
    }, {
      label: '已通过',
      value: 3
    }, {
      label: '未通过',
      value: 4
    }
  ],
  dimissionDateType: [
    {
      label: '离职日期',
      value: 1
    }, {
      label: '审批日期',
      value: 2
    }
  ],
  // 离职管理 任职状态 在职、离职
  resignationStatus: [
    {
      label: '在职',
      value: 1
    }, {
      label: '离职',
      value: 2
    }
  ],
  dimissionType: [
    {
      label: '离职',
      value: 2
    }, {
      label: '离职待审批',
      value: 5
    }, {
      label: '离职未通过',
      value: 6
    }
  ],
  contractType: [
    {
      label: '代理合同',
      value: 1
    }, {
      label: '劳务派遣',
      value: 2
    }, {
      label: '劳动合同',
      value: 3
    }, {
      label: '非全日制用工',
      value: 4
    }, {
      label: '劳务合同',
      value: 5
    }
  ],
  contractStatus: [
    {
      label: '未签订',
      value: 1
    }, {
      label: '未生效',
      value: 2
    }, {
      label: '生效中',
      value: 3
    }, {
      label: '已过期',
      value: 4
    }, {
      label: '已解约',
      value: 5
    }
  ],
  contractDateType: [
    {
      label: '合同生效日期',
      value: 1
    }, {
      label: '合同终止日期',
      value: 2
    }
  ],
  // 二次入司 任职状态 在职、待入职
  againEmploymentStatus: [
    {
      label: '待入职',
      value: 0
    }, {
      label: '在职',
      value: 1
    }
  ],
  // 二次入司 任职状态  在职 离职
  againEmploymentStatusList: [
    {
      label: '在职',
      value: 1
    }, {
      label: '离职',
      value: 2
    }
  ],
  // 任职状态 在职、离职、待入职
  employmentStatus: [
    {
      label: '待入职',
      value: 0
    }, {
      label: '在职',
      value: 1
    }, {
      label: '离职',
      value: 2
    }
  ],
  // 审批状态 待审批、已通过、未通过
  approvalStatus: [
    {
      label: '待审批',
      value: 1
    }, {
      label: '未通过',
      value: 2
    }, {
      label: '已通过',
      value: 3
    }
  ],
  officeholdingStatus: [
    {
      label: '在职',
      value: 1
    }, {
      label: '离职',
      value: 2
    }, {
      label: '入职待审批',
      value: 3
    }, {
      label: '入职未通过',
      value: 4
    }, {
      label: '离职待审批',
      value: 5
    }, {
      label: '离职未通过',
      value: 6
    }
  ],
  againOfficeholdingStatus: [
    {
      label: '在职',
      value: 3
    }, {
      label: '入职待审批',
      value: 1
    }, {
      label: '入职未通过',
      value: 2
    }
  ],
  managementDateType: [
    {
      label: '入职日期',
      value: 1
    }, {
      label: '审批日期',
      value: 2
    }
  ],
  operationDateType: [
    {
      label: '操作日期',
      value: 1
    }, {
      label: '生效日期',
      value: 2
    }
  ],
  practiceDateType: [
    {
      label: '发证日期',
      value: 1
    }, {
      label: '有效截止日期',
      value: 2
    }
  ],
  practiceStatusType: [
    {
      label: '未上编',
      value: 1
    }, {
      label: '已上编',
      value: 2
    }, {
      label: '已注销',
      value: -1
    }
  ],
  messageDateType: [
    {
      label: '入职日期',
      value: 1
    }, {
      label: '审批日期',
      value: 2
    }, {
      label: '合同生效日期',
      value: 3
    }, {
      label: '合同终止日期',
      value: 4
    }, {
      label: '发证日期',
      value: 5
    }, {
      label: '发证截止日期',
      value: 6
    }
  ],
  sourceStatus: [
    {
      label: '公众号',
      value: 1
    }, {
      label: '小程序',
      value: 2
    }, {
      label: '批量导入',
      value: 3
    }, {
      label: '单个新增',
      value: 4
    }, {
      label: '营销版',
      value: 5
    }, {
      label: '众包',
      value: 6
    }, {
      label: '邀请注册',
      value: 7
    }, {
      label: 'H5展业端',
      value: 8
    }, {
      label: '第三方自动注册',
      value: 9
    }
  ],
  salesOfficeType: [
    {
      label: '待维护',
      value: 0
    }, {
      label: '内勤',
      value: 1
    }, {
      label: '外勤',
      value: 2
    }
  ],
  salesOfficeTypeCompile: [
    {
      label: '内勤',
      value: 1
    }, {
      label: '外勤',
      value: 2
    }, {
      label: '推广员',
      value: 3
    }
  ],
  whetherShow: [
    {
      label: '展示',
      value: 1
    }, {
      label: '不展示',
      value: 2
    }
  ],
  personnelBusiType: [
    {
      label: '人管批量导入人员',
      value: 300
    }, {
      label: '人管批量更新人员',
      value: 8
    }, {
      label: '人管批量上编导入',
      value: 400
    }, {
      label: '人管批量离职',
      value: 310
    }, {
      label: '人管批量导入影像',
      value: 320
    }
  ],
  uploadType: [
    {
      label: '身份证',
      value: 1
    }, {
      label: '学历证',
      value: 2
    }, {
      label: '银行卡',
      value: 3
    }, {
      label: '免冠照片',
      value: 4
    }
  ],
  personnelUserStatus: [{
    value: 1, label: '启用'
  }, {
    value: 8, label: '禁用'
  }],
  enabledList: [{ // 启用状态 0-未启用 1-启用
    value: 0, label: '未启用'
  }, {
    value: 1, label: '启用'
  }],
  fileStatus: [{ // 文件状态 1-空 2-非空
    value: 1, label: '空'
  }, {
    value: 2, label: '非空'
  }],
  salesLevelList: [{ // 业务员等级: 1 - 实习、2-初级、3-中级、4-高级、5-资深
    value: '1', label: '实习'
  }, {
    value: '2', label: '四级（初级）'
  }, {
    value: '3', label: '三级（中级）'
  }, {
    value: '4', label: '二级（高级）'
  }, {
    value: '5', label: '一级（特级）'
  }],
  approvalTypeList: [{
    value: '1', label: '入职审批'
  }, {
    value: '2', label: '离职审批'
  }, {
    value: '3', label: '二次入司审批'
  }]
}

export default {
  personnel
}



// WEBPACK FOOTER //
// ./src/data/personnel.js